<template>
  <ul class="comments-list">
    <state-messages
      key="comment-states"
      :state="commentsState"
      :iconed="false"
    >
      <template v-slot:loading>
        Carregando comentários
      </template>

      <template v-slot:error>
        Algo deu errado enquanto tentávamos carregar os comentários.
        Por favor, tente novamente.
      </template>

      <template v-slot:empty>
        Nenhum comentário até agora
      </template>
    </state-messages>

    <comments-item
      v-for="(comment, id, index) in comments.items"
      :key="comment.id"
      :comment="comment"
      :next-date="nextDate(index)"
      :headless="headless(index)"
      :highlighted="highlighted(comment)"
      :position="position(comment)"
      class="comments-list-item"
    />
  </ul>
</template>

<script>
  import { mapState } from 'vuex';

  import moment from 'moment';

  import CommentsItem from '@/components/Comments/Item.vue';
  import StateMessages from '@/components/State/Messages.vue';

  export default {
    name: 'CommentsList',
    components: {
      CommentsItem,
      StateMessages,
    },
    props: {
      comments: {
        type: Object,
        default() {
          return {
            error: false,
            items: [],
            loading: false,
          };
        },
      },
    },
    computed: {
      ...mapState([
        'auth',
      ]),

      commentsState() {
        const {
          error,
          items,
          loading,
        } = this.comments;

        if (loading) {
          return 'loading';
        }

        if (error) {
          return 'error';
        }

        return Object.keys(items).length ? 'ready' : 'empty';
      },
      userIDs() {
        const {
          items,
        } = this.comments;

        return Object.keys(items).reduce((users, key) => {
          const {
            id,
          } = items[key].user;

          if (!users[id]) {
            return {
              ...users,
              [id]: true,
            };
          }

          return users;
        }, {});
      },
    },
    methods: {
      findComment(i) {
        const {
          items,
        } = this.comments;

        const k = Object.keys(items);
        return (k[i] && items[k[i]] && items[k[i]]) || {};
      },

      nextDate(index) {
        const f = i => this.findComment(i).created_at;

        const yesterday = moment(f(index - 1)).startOf('days');
        const today = moment(f(index)).startOf('days');

        if (yesterday.diff(today, 'days')) {
          return moment(f(index)).format('DD/MM/YYYY');
        }

        return null;
      },
      headless(index) {
        if (index > 0) {
          const f = i => this.findComment(i).user.id;

          if (f(index) === f(index - 1) && !this.nextDate(index)) {
            return true;
          }
        }

        return false;
      },
      position(comment) {
        return this.highlighted(comment) ? 'right' : 'left';
      },
      highlighted(comment) {
        return comment.user.id === this.auth.user.id;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .comments-list {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    list-style: none;
    padding: $gutter 0;

    @media all and (min-width: $breakpoint-desktop) {
      &:last-child {
        margin-bottom: $gutter;
      }
    }
  }
</style>
